module.exports = __webpack_public_path__ + "img/02p_marketing.37c3fc93.jpg";